import React, {useRef} from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";

interface CountryCodeSelectProps {
    selectCountry: (countryCode: string) => void;
    countries: { name: string; code: string; flag: string }[];
}

const CountryCodeSelect: React.FC<CountryCodeSelectProps> = ({selectCountry, countries}) => {

    return (
        <div className={styles.wrapper}>
            <div className={styles.main}>
                {countries.map((country, index) => (
                    <div
                        key={index}
                        onClick={() => selectCountry(country.code)}
                        className={styles.item}
                    >
                        <div className={classNames(styles.inner, {
                            [styles.lastItem]: index === countries.length - 1,
                        })}>
                            <div className={styles.flagAndNameWrapper}>
                                <span className={styles.flag}>{country.flag}</span>
                                <span className={styles.countryName}>{country.name}</span>
                            </div>
                            <span className={styles.countryCode}>{country.code}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CountryCodeSelect;